import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-children',
  templateUrl: './children.component.html',
  styleUrls: ['./children.component.scss']
})
export class ChildrenComponent implements OnInit {
  childLink = environment.link_child;

  constructor() { }

  ngOnInit() {
    // Redirect to external link
    window.location.href = this.childLink;
  }
}
